import React, { useEffect } from 'react'
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import HomeIcon from '@mui/icons-material/Home';
import { Link, useNavigate } from "react-router-dom";
import { getCategoryList, getInvestorCategoryList, getOEMCategoryList } from '../../networkCalls';

const promise = getCategoryList();
const promise2 = getInvestorCategoryList();
const promise3 = getOEMCategoryList();
const LeftMenuHeader = () => {
    const navigate = useNavigate();
    const [catlist, setCatlist] = React.useState();
    const [investorData, setInvestorData] = React.useState([]);
    const [catlistOEM, setCatlistOEM] = React.useState([]);

    //console.log('investorData', investorData)
    useEffect(() => {
        promise.then(data => {
            setCatlist(data?.CategoryListArray);
        });
    }, [catlist]);
    useEffect(() => {
        promise2.then(data => {
            setInvestorData(data?.InvestorCategoryListArray);
        });
    }, [investorData]);

    const ManageOEMLandingPAge = (slug, catID, itemdata) =>{
        // console.log('slug', slug)
        // console.log('catId', catId)
        // console.log('subCatId', subCatId)
        navigate(`/oem-category/${slug}`, {state:{catID, itemdata}});
    }
    
    useEffect(() => {
        promise3.then(data => {
            console.log('data setCatlistOEM', data)
            setCatlistOEM(data?.OEMCategoryListArray);
        });
    }, []);

    return (
        <>
            <Navbar collapseOnSelect expand="xs" className="m-0 position-static" >
                {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" className='m-0' /> */}
                <Navbar.Collapse id="responsive-navbar-nav" className='navbar-collapse collapse show'>
                    <Nav className="me-auto f16">
                        <Link className="pt-1 pe-1 nav-link txtdgray" to="/" ><HomeIcon className='txtred' /></Link>
                        <Link className="nav-link txtdgray" to="/about-us" >About Us</Link>
                        <NavDropdown title="Honda Products" id="collasible-nav-dropdown" className='maga-menu position-static'>
                            <div className="">
                                <div className="row bg-white rounded-0 m-0">
                                    {/* <div className="col-lg-9 col-xl-9"> */}
                                    <div className="col-lg-12">
                                        <div className="row">
                                            {catlist && catlist?.length > 0 && catlist?.map((data, key) => (
                                                <a href={`/product-category/${data?.slug}`} state={{ catID: data?.id }} key={key} >
                                                    <div className="col-lg-12 mb-2" >
                                                        <div className='card'>
                                                            <div className='p-2'>
                                                                <img src={data?.image} style={{ width: '50px' }} alt={data?.name} />
                                                                <span className='text-black f12 fw-bold ms-2'>{data?.name}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-xl-3 px-0 d-none d-lg-block megaimaga"></div>
                                </div>
                            </div>
                        </NavDropdown>
                        {catlistOEM && catlistOEM?.length > 0 ? <>
                            <NavDropdown title="HI+ Powered by Honda" id="collasible-nav-dropdown" className='maga-menu position-static'>
                            <div className="">
                                <div className="row bg-white rounded-0 m-0">
                                    {/* <div className="col-lg-9 col-xl-9"> */}
                                    <div className="col-lg-12">
                                        <div className="row">
                                            {/* {catlistOEM && catlistOEM?.length > 0 && catlistOEM?.map((data, index) => {
                                                return (
                                                    data && data?.subCategory && data?.subCategory?.length > 0 && data.subCategory?.map((item, key) => (
                                                        // <a href={`/oem-category/${data?.slug}`} state={{ catID: data?.id }}  key={key} >
                                                            <div className="col-lg-12 mb-2" role='button' onClick={()=>ManageOEMLandingPAge(data?.slug, data?.id, item )} key={key} >
                                                                <div className='card'>
                                                                    <div className='p-2'>
                                                                        <img src={item?.image} style={{ width: '50px' }} alt={item?.name} />
                                                                        <span className='text-black f12 fw-bold ms-2'>{item?.name}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        // </a>
                                                    ))
                                                );
                                            })} */}
                                            {catlistOEM?.map((data, key) => (
                                                <a href={`/oem-category/${data?.slug}`} state={{ catID: data?.id }} key={key} >
                                                    <div className="col-lg-12 mb-2" >
                                                        <div className='card'>
                                                            <div className='p-2'>
                                                                <img src={data?.image} style={{ width: '50px' }} alt={data?.name} />
                                                                <span className='text-black f12 fw-bold ms-2'>{data?.name}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-xl-3 px-0 d-none d-lg-block megaimaga"></div>
                                </div>
                            </div>
                        </NavDropdown>
                        </>:<></>}
                        <Link className="nav-link txtdgray " to="/hi-value-plus" >HI Value<sup>+</sup> <span className='f13'>(Refurbished Products)</span></Link>
                        <NavDropdown title="Investors" id="investor-nav-dropdown" className='maga-menu position-static'>
                            <div className="bg-white">
                                <div className="subleftmenu imvestor-wrap-menu">
                                <a href={`/board-of-directors`} className="text-black d-block dropdown-item"  >Board of Directors</a>
                                </div>
                               
                                {investorData && investorData?.length > 0 && investorData?.map((data, key) => (
                                    <div key={key} className="subleftmenu imvestor-wrap-menu">
                                         
                                         {data && data?.SubCategoryList?.length > 0 ? <>
                                            <NavDropdown title={data?.name} id={data?.slug} className='maga-menu position-static subcatinvestor'>
                                                {data?.SubCategoryList?.map((itemin, i) => (
                                                  <div key={i} className='sub-subcatelist'>
                                                        {itemin && itemin?.SubCategoryList?.length > 0 ?<>
                                                            <div className="dropdown-item subleftmenu align-items-center justify-content-between">
                                                                <a href={`/investors/${itemin?.slug}`} className="text-muted d-block"  >{itemin?.name}</a>
                                                            </div>
                                                        </>:<>
                                                        <div className="dropdown-item subleftmenu align-items-center justify-content-between">
                                                            <a href={`/investors/${itemin?.slug}`} className="text-muted d-block"  >{itemin?.name}</a>
                                                        </div>
                                                        </>}
                                                  </div>
                                                ))}
                                            </NavDropdown></> :
                                            <>
                                            <a href={`/investors/${data?.slug}`} className="text-black d-block dropdown-item"  >{data?.name}</a>
                                        </>}
                                    </div>
                                ))}
                            </div>
                        </NavDropdown>
                        <NavDropdown title="Customer Care" id="Customer-nav-dropdown" className='maga-menu position-static'>
                            <div className="">
                                <div className="row bg-white rounded-0 m-0">
                                    {/* <div className="col-lg-9 col-xl-9"> */}
                                    <div className="col-lg-12">
                                        <div className="row">
                                            <div className="col-lg-12 mb-2">
                                                <a href="https://www.hondappsv.com/IND/" target="_blank" className="dropdown-item subleftmenu pt-2 pb-2">Maintenance & Care Information</a>
                                                <Link to="/extended-warranty" className="dropdown-item subleftmenu pt-2 pb-2">Extended warranty</Link>
                                                <Link to="/honda-genuine-oil" className="dropdown-item subleftmenu pt-2 pb-2">Honda Genuine Oil</Link>
                                                {/* <Link to="/service-network" className="dropdown-item subleftmenu pt-2 pb-2">Service Network</Link> */}
                                                <Link to="/calculator" className="dropdown-item subleftmenu pt-2 pb-2">Model Calculator</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-xl-3 px-0 d-none d-lg-block megaimaga"></div>
                                </div>
                            </div>
                        </NavDropdown>
                        <Link className="nav-link txtdgray" to="/exports" >Exports</Link>
                        {/* <Link className="nav-link txtdgray" to="/press-release" >Press Release</Link>
                        <Link className="nav-link txtdgray" to="/events" >Events</Link> */}
                        <Link className="nav-link txtdgray" to="/events" >Newsroom</Link> 
                        {/* <Link className="nav-link txtdgray" to="/careers" >Careers</Link> */}
                        <a className="nav-link txtdgray" href="https://careers.hondaasiaoceania.com/go/HIPP-Jobs/665444/" target='_blank'>Careers</a>
                        <Link className="nav-link txtdgray" to="/oem-registration" >OEM ( Engine Business)</Link>
                        
                        <NavDropdown title="Dealers" id="Dealers-nav-dropdown" className='maga-menu position-static'>
                            <div className="">
                                <div className="row bg-white rounded-0 m-0">
                                    {/* <div className="col-lg-9 col-xl-9"> */}
                                    <div className="col-lg-12">
                                        <div className="row">
                                            <div className="col-lg-12 mb-2">
                                               
                                                <Link to="/service-network" className="dropdown-item subleftmenu pt-2 pb-2">Find Your Nearest Dealer</Link>
                                                <Link to="/become-a-dealer" className="dropdown-item subleftmenu pt-2 pb-2">Become an Authorized Honda Dealer</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-xl-3 px-0 d-none d-lg-block megaimaga"></div>
                                </div>
                            </div>
                        </NavDropdown>
                        <Link className="nav-link txtdgray" to="/contact-us">Contact Us</Link>
                        {/* <NavDropdown title="Jobs" id="collasible-nav-dropdown">
                            <Link to="#" className="dropdown-item">Link 1</Link>
                            <Link to="#" className="dropdown-item">Link 1</Link>
                        </NavDropdown> */}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </>
    )
}

export default LeftMenuHeader